import { useCallback } from 'react';
import { ITcoLocations, ITCOSubmission } from 'types';
import { tcoFieldsIds } from 'utils/defaultsAndConstants';
import { useQueryData } from './useQueryData';
import { useUpdateTcoLocations } from './apiHooks/tcoLocations/useUpdateTcoLocations';

interface IRefreshUnderlaySelectionsConfig {
  latestSubmission?: Partial<ITCOSubmission>;
  tcoSubmissions: ITCOSubmission[];
  tcoLocations: ITcoLocations[];
  refresh?: Boolean;
}

// Resets TCO Underlay Selections (of TCO locations) with initial pricing and latest formula
export const useRefreshTcoUnderlaySelections = () => {
  const { allTcoUnderlayProducts } = useQueryData();
  const { updateTcoLocations } = useUpdateTcoLocations();
  const { termsFieldId } = tcoFieldsIds;

  const refreshUnderlaySelections = useCallback(
    ({
      latestSubmission,
      tcoLocations = [],
      tcoSubmissions = [],
      refresh = false,
    }: IRefreshUnderlaySelectionsConfig) => {
      const termFieldValue = tcoSubmissions.find(
        (s) => s.fieldId === termsFieldId
      )?.answer;

      if (
        (latestSubmission && latestSubmission.fieldId === termsFieldId) ||
        refresh
      ) {
        tcoLocations.forEach((l) => {
          if (l.underlaySelections.length) {
            const newUnderlaySelections = l.underlaySelections.map((s) => {
              const selectedProductPrice = allTcoUnderlayProducts
                .find((u) => u.id === s.underlayId)
                ?.prices.find((p) => p.term === termFieldValue);
              if (selectedProductPrice) {
                return {
                  ...s,
                  spectrumPrice: selectedProductPrice.spectrumPrice,
                  diyPrice: selectedProductPrice.diyPrice,
                };
              }
              return s;
            });
            updateTcoLocations({
              ...l,
              underlaySelections: newUnderlaySelections,
            });
          }
        });
      }
    },
    [allTcoUnderlayProducts, termsFieldId, updateTcoLocations]
  );

  return { refreshUnderlaySelections };
};
